import { useEffect } from 'react';
import { RegionTypes } from '../../../config/regions';
import { buildLocalizeRoute } from '../../../helpers/languageHelper';
import { useNavigate, useLocation } from 'react-router-dom';

export const RegionHandler = () => {
	let currentRegion = localStorage.getItem('region') || RegionTypes.Global;
	const navigate = useNavigate();
	const location = useLocation();
	useEffect(() => {
		const originalPath = location.pathname.replace(/^\//, '') + location.search + location.hash;
		navigate(buildLocalizeRoute(originalPath, currentRegion), { replace: true });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);


	return null;
};

export default RegionHandler;
